<template>
    <div class="col-md-12">
        <BlockUI :message="msg" :html="html" v-if="loading"></BlockUI>
        <div v-else>
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">Work Order Details
                        <span v-if='WorkOrderDetails.status == 0'><span class="badge badge-danger">Pending</span></span>
                        <span v-if='WorkOrderDetails.status == 1'><span class="badge badge-success">Approved</span></span>
                    </h4>
                    <div class="row">
                        <div class="col-md-8">
                            <table class="table table-sm ">
                                <tr>
                                    <th>Assignment Level</th>
                                    <td v-if="WorkOrderDetails.assignment_level == 'project_level'">
                                        Project Level
                                    </td>

                                    <td v-if="WorkOrderDetails.assignment_level == 'zone_level'">
                                        Zone Level
                                    </td>

                                    <td v-if="WorkOrderDetails.assignment_level == 'plot_level'">
                                        Plot Level
                                    </td>

                                </tr>
                                <tr>
                                    <th>Activity Type</th>
                                    <td>{{ WorkOrderDetails.activity_type }}</td>
                                </tr>
                                <tr>
                                    <th>Project Name</th>
                                    <td>{{ WorkOrderDetails.project_name }}</td>
                                </tr>
                                <tr
                                    v-if="WorkOrderDetails.assignment_level == 'zone_level' || WorkOrderDetails.assignment_level == 'plot_level'">
                                    <th>Zone Name</th>
                                    <td>{{ WorkOrderDetails.zone_code }}</td>
                                </tr>
                                <tr v-if="WorkOrderDetails.assignment_level == 'plot_level'">
                                    <th>Plot Name</th>
                                    <td>{{ WorkOrderDetails.plot_code }}</td>
                                </tr>
                                <tr>
                                    <th>Description</th>
                                    <td>{{ WorkOrderDetails.description }}</td>
                                </tr>
                                <tr>
                                    <th>Start Date</th>
                                    <td>{{ WorkOrderDetails.start_date | moment("ddd,Do MMM YYYY") }}</td>
                                </tr>
                                <tr>
                                    <th>End Date</th>
                                    <td>{{ WorkOrderDetails.end_date | moment("ddd,Do MMM YYYY") }}</td>
                                </tr>
                                <tr>
                                    <th>Frequency</th>
                                    <td>{{ WorkOrderDetails.frequency }}</td>
                                </tr>
                                <tr>
                                    <th>No of Worker</th>
                                    <td>{{ WorkOrderDetails.no_of_workers }}</td>
                                </tr>
                                <tr>
                                    <th>Resources</th>
                                    <td>{{ WorkOrderDetails.resource }}</td>
                                </tr>
                                <tr>
                                    <th>Status</th>
                                    <td v-if='WorkOrderDetails.current_status == 1'> Pending</td>
                                    <td v-if='WorkOrderDetails.current_status == 2'> In Progress</td>
                                    <td v-if='WorkOrderDetails.current_status == 3'> Completed</td>
                                </tr>
                                <tr>
                                    <th>Progress</th>
                                    <td>{{ WorkOrderDetails.progress }} %</td>
                                </tr>
                            </table>
                        </div>
                      
                        <div class="col-md-4">
                            <b-carousel id="carousel-no-animation" style="text-shadow: 0px 0px 2px #000" no-animation
                                indicators controls img-width="400" img-height="400">
                                <b-carousel-slide 
                                v-for="(image, k) in WorkOrderDetails.image_url"
                                :img-src="image" :key="k"></b-carousel-slide>

                            </b-carousel>
                        </div>
                        <div class="col-md-8">
                           
                           <h4 class="card-title">Argonomist Aligned to this Work Order</h4>
                       <table class="table table-sm table-bordered">
                           <thead>
                               <tr class="thead-light">
                                   <th>#</th>
                                   <th>Name</th>
                                   <th>Phone</th>
                               </tr>
                           </thead>
                           <tbody>
                               <tr v-for="(user, i) in UserAlignmentDetails" :key="i">
                                   <td>{{ 1 + i }}.</td>
                                   <td>
                                       {{ user.name }}

                                   </td>
                                   <td>{{ user.phone }}</td>
                               </tr>
                           </tbody>
                       </table>
                          
                       </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            msg: 'Loading ..',
            html: '<i class="fa fa-cog fa-spin fa-3x fa-fw"></i>',
            loading: true,
            WorkOrderDetails: false,
            UserAlignmentDetails: [],
        }
    },
    mounted() {
        this.getOrgDetails();
    },
    methods: {
        getOrgDetails() {
            let id = this.$route.params.workOrderId;
            window.axios.get("/work-orders/" + id,)
                .then((resp) => {
                    console.log(resp.data.data);
                    this.loading = false;
                    this.WorkOrderDetails = resp.data.data.work_order_details;
                    this.UserAlignmentDetails = resp.data.data.alignment_users
                });
        }
    }
}
</script>
<style>
.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-color: #0d0c0c;
  padding:30px;
}
.carousel-control-prev-icon{
    margin-right: 107px !important;
}

.carousel-control-prev-icon{
    margin-left: 107px;
}
.carousel-indicators  {
    background-color: #fff;
    margin-bottom: 2px;
}
.carousel-indicators li {
    background-color: #0d0c0c;
    padding: 1px;
}
</style>